export enum StatisticsListSectionNames {
  TOTAL = 'total',
  CASINO = 'casino',
  BETTING = 'betting',
}
